/**
 * @component BetaBadge
 * @description Generischer, wiederverwendbarer Beta-Hinweis (#1208).
 * Dezent orange Pille mit Tooltip „Noch nicht produktiv nutzen".
 * Einsetzbar neben Seitentiteln, in der Sidebar oder an beliebigen Stellen.
 *
 * @prop {('sm'|'md')} [size]   - Größe (sm = kompakt für Sidebar)
 * @prop {string}      [title]  - Tooltip-Text (default i18n-unabhängig deutsch)
 * @prop {string}      [label]  - Sichtbarer Text (default „Beta")
 * @prop {string}      [className]
 */
export default function BetaBadge({ size = 'md', title = 'Noch nicht produktiv nutzen', label = 'Beta', className = '' }) {
  const sizeCls = size === 'sm'
    ? 'text-[9px] px-1.5 py-[1px]'
    : 'text-[10px] px-2 py-0.5';
  return (
    <span
      title={title}
      className={`inline-flex items-center gap-1 rounded-full font-semibold uppercase tracking-wide
        bg-[#F59E0B]/12 text-[#B45309] border border-[#F59E0B]/30 leading-none ${sizeCls} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-[#F59E0B]" />
      {label}
    </span>
  );
}
